import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "arrowRightCircleFilled"
const ArrowRightCircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-4.975-9.15h7.928l-2.373 2.71c-.295.339-.253.904.083 1.21.341.313.91.265 1.212-.084l3.616-4.131c.276-.368.271-.792.002-1.125l-.002-.002-3.616-4.132a.858.858 0 0 0-1.21-.085.889.889 0 0 0-.086 1.211l2.373 2.711H7.026a.858.858 0 1 0 0 1.716Z"
          />
        </svg>
      }
    </span>
  )
}
export default ArrowRightCircleFilledIcon
